import { Container, Grid, Parse, Section } from '@/components/Core'
import { Lib } from '@/types'
import clsx from 'clsx'
import { readFragment } from 'gql.tada'
import { memo } from 'react'
import SectionFullWidthContentFragment from './query'

export interface SectionFullWidthContentProps {
  data: Lib.FragmentOf<typeof SectionFullWidthContentFragment>
}

export type SectionFullWidthContentData = Lib.FragmentOf<
  typeof SectionFullWidthContentFragment
> & {
  _modelApiKey: 'section_full_width_content'
  __typename: 'SectionFullWidthContentRecord'
  id: string
}

const SectionFullWidthContent = ({ data }: SectionFullWidthContentProps) => {
  const d = readFragment(SectionFullWidthContentFragment, data)

  return (
    <Section
      className={clsx('py-vertical-main')}
      sectionName={d._modelApiKey}
      mainWrapper={false}
      anim="section-fade-in"
    >
      <Container>
        <Grid>
          <div className="gap-md col-span-12 flex flex-col lg:col-span-10 lg:col-start-2">
            {d.title && (
              <h2 className="hyphens">
                <Parse html={d.title} excludeTags={['p']} />
              </h2>
            )}
            <div className="h-[600px] min-[1700px]:!h-[900px] min-[1920px]:!h-[1000px] md:h-[640px] xl:h-[750px] 2xl:h-[850px]">
              <Parse html={d.content} excludeTags={['p']} />
            </div>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default memo(SectionFullWidthContent)
